import { render, staticRenderFns } from "./Xianyu.vue?vue&type=template&id=1abdb798&scoped=true"
import script from "./Xianyu.vue?vue&type=script&lang=js"
export * from "./Xianyu.vue?vue&type=script&lang=js"
import style0 from "./Xianyu.vue?vue&type=style&index=0&id=1abdb798&prod&scoped=true&lang=css"
import style1 from "./Xianyu.vue?vue&type=style&index=1&id=1abdb798&prod&lang=scss&scoped=true"
import style2 from "./Xianyu.vue?vue&type=style&index=2&id=1abdb798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4.17.21_kzgbr7tkrfh4tbz6eswufdvi6i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abdb798",
  null
  
)

export default component.exports